import React, { useEffect, useState } from "react";
import { FieldArray, FormikProvider, useFormik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as jnb from "react-bootstrap";
import allowNumbersOnly from "../../CommonUtils/CommonValidations";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import Swal from "sweetalert2";
import { failureAlert, successAlert2 } from "../../CommonUtils/SweetAlerts";
import { ImagePdfBucket } from "../../CommonUtils/ImagesBase64";
import { FaEye, FaUniversity } from "react-icons/fa";
import { viewImage } from "../../CommonUtils/viewImage";
//mamali,priyanka

// eslint-disable-next-line react/prop-types
const AdmissionAndResultAnalysis = ({ hide, onFirstTabSubmit }) => {
  const [intakeData, setIntakeData] = useState([]);
  const [freezeAreaType, setFreezeAreaType] = useState(false);
  const [disableFields, setDisableFields] = useState({ coll_area_type: false })
  const userId = sessionStorage.getItem("user_id")
  const [hasExistingData, setHasExistingData] = useState(false);
  const initialValues = {
    collegeLocation: "",
    certificateDoc: "",
    admissionDetails: [],
    resultAnalysis: [],
    nacAvailable: "",
    ugc2f: "",
    ugc2fCertificate: "",
    ugc12b: "",
    ugc12bCertificate: "",

  };

  /* ================= VALIDATION SCHEMA ================= */
  const validationSchema = Yup.object().shape({
    collegeLocation: Yup.string()
      .required("College Location Is Required"),
    ugc2f: Yup.string().required(" ugc2f is required"),
    ugc12b: Yup.string().required("ugc12b is required"),
    ugc2fCertificate: Yup.string().when('ugc2f', {
      is: 'yes',
      then: (schema) => schema.required('UGC 2(F) certificate is required'),
    }),
    ugc12bCertificate: Yup.string().when('ugc12b', {
      is: 'yes',
      then: (schema) => schema.required('UGC 12(B) certificate is required'),
    }),


    admissionDetails: Yup.array().of(
      Yup.object().shape({
        // stream_name: Yup.string().required(ERROR_MSG),
        // single_major_name: Yup.string().required(ERROR_MSG),
        sanctionedIntakeYear1: Yup.string().required(ERROR_MSG),
        sanctionedIntakeYear2: Yup.string().required(ERROR_MSG),
        sanctionedIntakeYear3: Yup.string().required(ERROR_MSG),
        admittedYear1: Yup.string().required(ERROR_MSG),
        admittedYear2: Yup.string().required(ERROR_MSG),
        admittedYear3: Yup.string().required(ERROR_MSG),
        admissionPercentYear1: Yup.string().required(ERROR_MSG),
        admissionPercentYear2: Yup.string().required(ERROR_MSG),
        admissionPercentYear3: Yup.string().required(ERROR_MSG),
        // sem5Students: Yup.string().required(ERROR_MSG),
        // sem5Percent: Yup.string().required(ERROR_MSG),
        sem5Students: Yup.string()
          .required(ERROR_MSG)
          .test('sem5-validation', '5th Sem students should not exceed III Year admitted students', function (value) {
            const { admittedYear3 } = this.parent;//NOSONAR
            const sem5 = Number(value) || 0;
            const admitted = Number(admittedYear3) || 0;

            if (sem5 > admitted) {
              return this.createError({//NOSONAR
                message: '5th Sem students should not exceed III Year admitted students'
              });
            }
            return true;
          }),

        sem5Percent: Yup.string().required(ERROR_MSG),
        sem6Students: Yup.string()
          .required(ERROR_MSG)
          .test('sem6-validation', '6th Sem students should not exceed III Year admitted students', function (value) {
            const { admittedYear3 } = this.parent;//NOSONAR
            const sem6 = Number(value) || 0;
            const admitted = Number(admittedYear3) || 0;

            if (sem6 > admitted) {
              return this.createError({//NOSONAR
                message: '6th Sem students should not exceed III Year admitted students'
              });
            }
            return true;
          }),


        sem6Percent: Yup.string().required(ERROR_MSG),
        // sem6Students: Yup.string().required(ERROR_MSG),
        // sem6Percent: Yup.string().required(ERROR_MSG),
      }),
    ),


    resultAnalysis: Yup.array().of(
      Yup.object().shape({
        // stream_name: Yup.string().required(ERROR_MSG),
        // ug_programme_name: Yup.string().required(ERROR_MSG),
        // appearedYear1: Yup.string().required(ERROR_MSG),
        // passedYear1: Yup.string()
        //   .required(ERROR_MSG)
        //   .test(
        //     'pass-leq-appear-1',
        //     'Passed students should not exceed appeared students (2020-2023)',
        //     function (value) {
        //       const appeared = this.parent.appearedYear1; // NOSONAR
        //       const pass = Number(value) || 0;
        //       const appear = Number(appeared) || 0;
        //       return appear === 0 ? pass === 0 : pass <= appear;
        //     }
        //   ),
        // percentYear1: Yup.string().required(ERROR_MSG),
        appearedYear2: Yup.string().required(ERROR_MSG),
        // passedYear2: Yup.string().required(ERROR_MSG),
        passedYear2: Yup.string()
          .required(ERROR_MSG)
          .test(
            'pass-leq-appear-2',
            'Passed students should not exceed appeared students (2021-2024)',
            function (value) {
              const appeared = this.parent.appearedYear2; // NOSONAR
              const pass = Number(value) || 0;
              const appear = Number(appeared) || 0;
              return appear === 0 ? pass === 0 : pass <= appear;
            }
          ),
        percentYear2: Yup.string().required(ERROR_MSG),
        appearedYear3: Yup.string().required(ERROR_MSG),
        // passedYear3: Yup.string().required(ERROR_MSG),
        passedYear3: Yup.string()
          .required(ERROR_MSG)
          .test(
            'pass-leq-appear-3',
            'Passed students should not exceed appeared students (2022-2025)',
            function (value) {
              const appeared = this.parent.appearedYear3; // NOSONAR
              const pass = Number(value) || 0;
              const appear = Number(appeared) || 0;
              return appear === 0 ? pass === 0 : pass <= appear;
            }
          ),
        percentYear3: Yup.string().required(ERROR_MSG),
      }),
    ),


    // admissionDetails: Yup.array().of(
    //   Yup.lazy((value) => {
    //     console.log("Validating:", value?.stream_name);
    //     if (value?.stream_name === "PG ACADEMIC") {
    //       return Yup.object().shape({});
    //     }

    //     return Yup.object().shape({
    //       stream_name: Yup.string().required(ERROR_MSG),
    //       single_major_name: Yup.string().required(ERROR_MSG),

    //       sanctionedIntakeYear1: Yup.string().required(ERROR_MSG),
    //       sanctionedIntakeYear2: Yup.string().required(ERROR_MSG),
    //       sanctionedIntakeYear3: Yup.string().required(ERROR_MSG),

    //       admittedYear1: Yup.string().required(ERROR_MSG),
    //       admittedYear2: Yup.string().required(ERROR_MSG),
    //       admittedYear3: Yup.string().required(ERROR_MSG),

    //       admissionPercentYear1: Yup.string().required(ERROR_MSG),
    //       admissionPercentYear2: Yup.string().required(ERROR_MSG),
    //       admissionPercentYear3: Yup.string().required(ERROR_MSG),

    //       sem5Students: Yup.string()
    //         .required(ERROR_MSG)
    //         .test(
    //           "sem5-validation",
    //           "5th Sem students should not exceed III Year admitted students",
    //           function (value) {
    //             const { admittedYear3 } = this.parent; // NOSONAR
    //             const sem5 = Number(value) || 0;
    //             const admitted = Number(admittedYear3) || 0;

    //             if (sem5 > admitted) {
    //               return this.createError({
    //                 message:
    //                   "5th Sem students should not exceed III Year admitted students",
    //               });
    //             }

    //             return true;
    //           }
    //         ),

    //       sem5Percent: Yup.string().required(ERROR_MSG),

    //       sem6Students: Yup.string()
    //         .required(ERROR_MSG)
    //         .test(
    //           "sem6-validation",
    //           "6th Sem students should not exceed III Year admitted students",
    //           function (value) {
    //             const { admittedYear3 } = this.parent; // NOSONAR
    //             const sem6 = Number(value) || 0;
    //             const admitted = Number(admittedYear3) || 0;

    //             if (sem6 > admitted) {
    //               return this.createError({
    //                 message:
    //                   "6th Sem students should not exceed III Year admitted students",
    //               });
    //             }

    //             return true;
    //           }
    //         ),

    //       sem6Percent: Yup.string().required(ERROR_MSG),
    //     });
    //   })
    // ),

  });

  /* ================= FORMIK SETUP ================= */
  const admissionFormik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save the admission and result analysis data?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          const transformedResults = values.resultAnalysis.map(item => ({

            streamName: item.stream_name,
            ugProgrammeName: item.ug_programme_name,
            appearedYear2023: item.appearedYear1,
            passedYear2023: item.passedYear1,
            percentYear2023: item.percentYear1,
            appearedYear2124: item.appearedYear2,
            passedYear2124: item.passedYear2,
            percentYear2124: item.percentYear2,
            appearedYear2225: item.appearedYear3,
            passedYear2225: item.passedYear3,
            percentYear2225: item.percentYear3,
          }));
          const transformedAdmissions = values.admissionDetails.map(item => ({
            streamName: item.stream_name,
            singleMajorName: item.single_major_name,
            sanctionedIntakeYear1: item.sanctionedIntakeYear1,
            sanctionedIntakeYear2: item.sanctionedIntakeYear2,
            sanctionedIntakeYear3: item.sanctionedIntakeYear3,
            admittedYear1: item.admittedYear1,
            admittedYear2: item.admittedYear2,
            admittedYear3: item.admittedYear3,
            admissionPercentYear1: item.admissionPercentYear1,
            admissionPercentYear2: item.admissionPercentYear2,
            admissionPercentYear3: item.admissionPercentYear3,
            sem5Students: item.sem5Students,
            sem5Percent: item.sem5Percent,
            sem6Students: item.sem6Students,
            sem6Percent: item.sem6Percent,
          }));
          const payload = {
            admissionDetails: transformedAdmissions,
            resultAnalysis: transformedResults
          };
          const url = `${config.url.FAC_URL}saveAdmissionDtls`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                successAlert2(res.data.sdesc);
                getAfterSubmit();
                if (onFirstTabSubmit) {
                  onFirstTabSubmit();
                } else {
                  console.warn("onFirstTabSubmit is undefined");
                }
              }
              else {
                failureAlert(res.data.sdesc)
              }
            })
            .catch((err) => {
              console.error("Submission Error:", err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });

  useEffect(() => {
    getAfterSubmit()
  }, [])
  const [clgdata, setClgdata] = useState({});
  const [landDtls, setlandDtls] = useState([]);
  const [nacDetails, setNacDetails] = useState([])
  useEffect(() => {
    CommonAxiosGet(`${config.url.FAC_URL}getInstitutionPolyDetails`).then((res) => {
      const data = res?.data?.data?.[0] || {};
      setClgdata(data);
      setNacDetails(res?.data?.naacdtls || {})
    });


    CommonAxiosGet(`${config.url.FAC_URL}getSHiftingDetails`).then((res) => {
      const data = res?.data?.data?.[0] || {};
      setlandDtls(data);
    });

  }, []);
  console.log("errors", admissionFormik.errors)
  const getAfterSubmit = () => {
    const url = `${config.url.FAC_URL}getAdmissionDtls`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          if (res?.data?.admission_status && Array?.isArray(res.data.admission)) {
            const mappedAdmission = res?.data?.admission.map((item) => ({

              stream_name: item?.stream_name || "",
              single_major_name: item?.single_major_name || "",
              sanctionedIntakeYear1: item?.sanctioned_intake_year1?.toString() || "",
              sanctionedIntakeYear2: item?.sanctioned_intake_year2?.toString() || "",
              sanctionedIntakeYear3: item?.sanctioned_intake_year3?.toString() || "",
              admittedYear1: item.admitted_year1?.toString() || "",
              admittedYear2: item.admitted_year2?.toString() || "",
              admittedYear3: item.admitted_year3?.toString() || "",
              admissionPercentYear1: item.admission_percent_year1?.toString() || "",
              admissionPercentYear2: item.admission_percent_year2?.toString() || "",
              admissionPercentYear3: item.admission_percent_year3?.toString() || "",
              sem5Students: item.sem5_students?.toString() || "",
              sem5Percent: item.sem5_percent?.toString() || "",
              sem6Students: item.sem6_students?.toString() || "",
              sem6Percent: item.sem6_percent?.toString() || "",
            }));
            admissionFormik?.setFieldValue("admissionDetails", mappedAdmission);

            if (onFirstTabSubmit) {
              onFirstTabSubmit();
            } else {
              console.warn("onFirstTabSubmit is undefined");
            }
          }
          if (res.data.result_status && Array.isArray(res.data.result)) {
            const mappedResults = res?.data?.result.map((item) => ({
              stream_name: item.stream_name || "",
              ug_programme_name: item.ug_programme_name || "",
              // appearedYear1: item.appeared_year20_23?.toString() || "",
              // passedYear1: item.passed_year20_23?.toString() || "",
              // percentYear1: item.percent_year20_23?.toString() || "",
              appearedYear2: item.appeared_year21_24?.toString() || "",
              passedYear2: item.passed_year21_24?.toString() || "",
              percentYear2: item.percent_year21_24?.toString() || "",
              appearedYear3: item.appeared_year22_25?.toString() || "",
              passedYear3: item.passed_year22_25?.toString() || "",
              percentYear3: item.percent_year22_25?.toString() || "",
            }));
            admissionFormik?.setFieldValue("resultAnalysis", mappedResults);
          }

          const hasAdmissionData = res.data.admission_status &&
            Array.isArray(res.data.admission) &&
            res.data.admission.length > 0;
          const hasResultData = res.data.result_status &&
            Array.isArray(res.data.result) &&
            res.data.result.length > 0;
          setHasExistingData(hasResultData);
          setDisableFields({ coll_area_type: res.data.areaType?.length > 0 && res.data.areaType[0]?.coll_area_type })
          const areaData = res.data.areaType[0];
          if (
            res.data.areaType_status &&
            Array.isArray(res.data.areaType) &&
            res.data.areaType.length > 0
          ) {
            admissionFormik.setFieldValue(
              "collegeLocation",
              res.data.areaType[0].coll_area_type || ""
            );
            admissionFormik.setFieldValue(
              "certificateDoc",
              res.data.areaType[0].certificatedoc || ""
            );
            admissionFormik.setFieldValue(
              "ugc2f",
              areaData.ugc2f || ""
            );

            admissionFormik.setFieldValue(
              "ugc2fCertificate",
              areaData.ugc2f_certificate || ""
            );

            admissionFormik.setFieldValue(
              "ugc12b",
              areaData.ugc12b || ""
            );
            admissionFormik.setFieldValue(
              "ugc12bCertificate",
              areaData.ugc12b_certificate || ""
            );

            setFreezeAreaType(true);

          }
        }
      })
      .catch((err) => console.error("Error fetching saved admission data:", err));
  };
  /* ================= API FETCH ================= */
  function GetCourseDetails() {
    const url = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true && res?.data?.list?.length > 0) {
          const apiData = res?.data?.list;
          // Map for Table 1: Admission Details
          // const formattedAdmission = apiData?.map((course) => ({
          const formattedAdmission = apiData
            ?.filter((course) => course.course_group_desc !== "PG ACADEMIC")
            .map((course) => ({
              CourseType: course.course_group_desc,
              stream_name: course.course_cat_name,
              single_major_name: course.course_name,
              sanctionedIntakeYear1: "",
              sanctionedIntakeYear2: "",
              sanctionedIntakeYear3: "",
              admittedYear1: "",
              admittedYear2: "",
              admittedYear3: "",
              admissionPercentYear1: "",
              admissionPercentYear2: "",
              admissionPercentYear3: "",
              sem5Students: "",
              sem5Percent: "",
              sem6Students: "",
              sem6Percent: "",
            }));
          // Map for Table 2: Result Analysis
          // const formattedResults = apiData.map((course) => ({
          const formattedResults = apiData
            ?.filter((course) => course.course_group_desc !== "PG ACADEMIC")
            .map((course) => ({
              CourseType: course.course_group_desc,
              stream_name: course.course_cat_name,
              ug_programme_name: course.course_name,
              appearedYear1: "",
              passedYear1: "",
              percentYear1: "",
              appearedYear2: "",
              passedYear2: "",
              percentYear2: "",
              appearedYear3: "",
              passedYear3: "",
              percentYear3: "",
            }));
          admissionFormik.setFieldValue("admissionDetails", formattedAdmission);
          admissionFormik.setFieldValue("resultAnalysis", formattedResults);
          getAfterSubmit();
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }
  useEffect(() => {
    GetCourseDetails();
  }, []);
  const calculatePercentage = (admitted, intake) => {
    const a = Number(admitted) || 0;
    const i = Number(intake) || 0;
    return i > 0 ? ((a / i) * 100).toFixed(2) : "0.00";
  };
  const handleResultChange = (index, field, value) => {
    admissionFormik.setFieldValue(
      `resultAnalysis[${index}].${field}`,
      value
    );
    const row = admissionFormik.values.resultAnalysis[index];
    const calculatePercentage = (p, a) => {
      const passed = Number(p) || 0;
      const appeared = Number(a) || 0;
      return appeared > 0 ? ((passed / appeared) * 100).toFixed(2) : "0.00";
    };
    if (field === "appearedYear1" || field === "passedYear1") {
      const appeared =
        field === "appearedYear1" ? value : row.appearedYear1;
      const passed =
        field === "passedYear1" ? value : row.passedYear1;
      admissionFormik.setFieldValue(
        `resultAnalysis[${index}].percentYear1`,
        calculatePercentage(passed, appeared)
      );
    }
    if (field === "appearedYear2" || field === "passedYear2") {
      const appeared =
        field === "appearedYear2" ? value : row.appearedYear2;
      const passed =
        field === "passedYear2" ? value : row.passedYear2;
      admissionFormik.setFieldValue(
        `resultAnalysis[${index}].percentYear2`,
        calculatePercentage(passed, appeared)
      );
    }
    if (field === "appearedYear3" || field === "passedYear3") {
      const appeared =
        field === "appearedYear3" ? value : row.appearedYear3;
      const passed =
        field === "passedYear3" ? value : row.passedYear3;
      admissionFormik.setFieldValue(
        `resultAnalysis[${index}].percentYear3`,
        calculatePercentage(passed, appeared)
      );
    }
  };
  const handleAdmissionChange = (index, field, value) => {
    admissionFormik.setFieldValue(
      `admissionDetails[${index}].${field}`,
      value
    );
    const row = admissionFormik.values.admissionDetails[index];
    const calculatePercentage = (a, i) => {
      const adm = Number(a) || 0;
      const intake = Number(i) || 0;
      return intake > 0 ? ((adm / intake) * 100).toFixed(2) : "0.00";
    };

    if (field === "admittedYear1") {
      admissionFormik.setFieldValue(
        `admissionDetails[${index}].admissionPercentYear1`,
        calculatePercentage(value, row.sanctionedIntakeYear1)
      );
    }
    if (field === "admittedYear2") {
      admissionFormik.setFieldValue(
        `admissionDetails[${index}].admissionPercentYear2`,
        calculatePercentage(value, row.sanctionedIntakeYear2)
      );
    }
    if (field === "admittedYear3") {
      admissionFormik.setFieldValue(
        `admissionDetails[${index}].admissionPercentYear3`,
        calculatePercentage(value, row.sanctionedIntakeYear3)
      );
    }

    // if (field === "sem5Students") {
    //   admissionFormik.setFieldValue(
    //     `admissionDetails[${index}].sem5Percent`,
    //     calculatePercentage(value, row.admittedYear3)
    //   );
    // }

    // if (field === "sem6Students") {
    //   admissionFormik.setFieldValue(
    //     `admissionDetails[${index}].sem6Percent`,
    //     calculatePercentage(value, row.admittedYear3)
    //   );
    // }
    if (field === "sem5Students") {
      admissionFormik.setFieldValue(
        `admissionDetails[${index}].sem5Percent`,
        calculatePercentage(value, row.admittedYear3)
      );
      const sem5 = Number(value) || 0;
      const admitted = Number(row.admittedYear3) || 0;
      // Validation for 5th Sem only
      if (sem5 > admitted) {
        Swal.fire({
          icon: "warning",
          title: "Validation Alert",
          text: "5th Sem students should not exceed III Year admitted students",
          confirmButtonText: "OK"
        });
        // admissionFormik.setFieldValue(`admissionDetails[${index}].sem5Students`, "");
        // admissionFormik.setFieldValue(`admissionDetails[${index}].sem5Percent`, "");
      }
    }
    if (field === "sem6Students") {
      admissionFormik.setFieldValue(
        `admissionDetails[${index}].sem6Percent`,
        calculatePercentage(value, row.admittedYear3)
      );
      const sem6 = Number(value) || 0;
      const admitted = Number(row.admittedYear3) || 0;
      if (sem6 > admitted) {
        Swal.fire({
          icon: "warning",
          title: "Validation Alert",
          text: "6th Sem students should not exceed III Year admitted students",
        });
      }
      // admissionFormik.setFieldValue(`admissionDetails[${index}].sem6Students`, "");
      // admissionFormik.setFieldValue(`admissionDetails[${index}].sem6Percent`, "");

    }
  };
  // async function saveArea() {
  //   const payload = {
  //     areaType: admissionFormik.values.collegeLocation,
  //     certificateDoc: admissionFormik.values.certificateDoc,
  //     nacAvailable: admissionFormik.values.nacAvailable,
  //     ugc2f: admissionFormik.values.ugc2f,
  //     ugc2fCertificate: admissionFormik.values.ugc2fCertificate,
  //     ugc12b: admissionFormik.values.ugc12b,
  //     ugc12bCertificate: admissionFormik.values.ugc12bCertificate
  //   };
  //   const errors = await admissionFormik.validateForm();

  //   if (Object.keys(errors).length > 0) {
  //     admissionFormik.setTouched({
  //       nacAvailable: true,
  //       ugc2f: true,
  //       ugc12b: true,
  //       ugc2fCertificate: true,
  //       ugc12bCertificate: true,
  //     });
  //     return;
  //   }
  //   if (!admissionFormik.values.collegeLocation) {
  //     admissionFormik.setFieldTouched("collegeLocation", true);
  //     Swal.fire({
  //       icon: "warning",
  //       title: "Validation Error",
  //       text: "Please select College Location",
  //     });
  //     return;
  //   }

  //   // Validate certificate for rural/tribal
  //   if (admissionFormik.values.collegeLocation === "rural" ||
  //     admissionFormik.values.collegeLocation === "tribal") {
  //     if (!admissionFormik.values.certificateDoc) {
  //       admissionFormik.setFieldTouched("certificateDoc", true);
  //       Swal.fire({
  //         icon: "warning",
  //         title: "Validation Error",
  //         text: "Please upload certificate",
  //       });
  //       return;
  //     }
  //   }
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "Do you want to submit the area details?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, Submit",
  //     cancelButtonText: "Cancel",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       let url = `${config.url.FAC_URL}saveAreaType?areaType=${admissionFormik.values.collegeLocation}&certificateDoc=${admissionFormik.values.certificateDoc}&nacAvailable=${admissionFormik.values.nacAvailable}&ugc2f=${admissionFormik.values.ugc2f}&ugc2fCertificate=${admissionFormik.values.ugc2fCertificate}&ugc12b=${admissionFormik.values.ugc12b}&ugc12bCertificate=${admissionFormik.values.ugc12bCertificate}`;
  //       // let url = `${config.url.FAC_URL}saveAreaType?areaType=${admissionFormik.values.collegeLocation}&certificateDoc=${admissionFormik.values.certificateDoc}`;
  //       CommonAxiosPost(url, payload)
  //         .then((res) => {
  //           if (res?.data?.scode === "01") {
  //             successAlert2(res.data.sdesc);
  //             getAfterSubmit();
  //             // window.location.reload();
  //           }
  //           else {
  //             failureAlert(res.data.sdesc)
  //           }
  //         })
  //         .catch((err) => {
  //           console.error("Submission Error:", err);
  //           Swal.fire({
  //             text: "An error occurred during submission.",
  //             icon: "error",
  //           });
  //         });
  //     }
  //   });
  // }
  async function saveArea() {
    const payload = {
      areaType: admissionFormik.values.collegeLocation,
      certificateDoc: admissionFormik.values.certificateDoc,
      nacAvailable: admissionFormik.values.nacAvailable,
      ugc2f: admissionFormik.values.ugc2f,
      ugc2fCertificate: admissionFormik.values.ugc2fCertificate,
      ugc12b: admissionFormik.values.ugc12b,
      ugc12bCertificate: admissionFormik.values.ugc12bCertificate
    };

    // ========== VALIDATE ONLY AREA FIELDS (NOT THE WHOLE FORM) ==========
    const areaFields = {
      collegeLocation: admissionFormik.values.collegeLocation,
      ugc2f: admissionFormik.values.ugc2f,
      ugc12b: admissionFormik.values.ugc12b,
      ugc2fCertificate: admissionFormik.values.ugc2fCertificate,
      ugc12bCertificate: admissionFormik.values.ugc12bCertificate,
      certificateDoc: admissionFormik.values.certificateDoc
    };

    // Manually validate only the fields you care about
    const areaErrors = {};

    if (!areaFields.collegeLocation) {
      areaErrors.collegeLocation = "College Location Is Required";
    }
    if (!areaFields.ugc2f) {
      areaErrors.ugc2f = "ugc2f is required";
    }
    if (!areaFields.ugc12b) {
      areaErrors.ugc12b = "ugc12b is required";
    }
    if (areaFields.ugc2f === "yes" && !areaFields.ugc2fCertificate) {
      areaErrors.ugc2fCertificate = "UGC 2(F) certificate is required";
    }
    if (areaFields.ugc12b === "yes" && !areaFields.ugc12bCertificate) {
      areaErrors.ugc12bCertificate = "UGC 12(B) certificate is required";
    }
    if ((admissionFormik.values.collegeLocation === "rural" ||
      admissionFormik.values.collegeLocation === "tribal") &&
      !areaFields.certificateDoc) {
      areaErrors.certificateDoc = "Certificate is required";
    }

    // Set touched for area fields
    admissionFormik.setTouched({
      collegeLocation: true,
      ugc2f: true,
      ugc12b: true,
      ugc2fCertificate: admissionFormik.values.ugc2f === "yes",
      ugc12bCertificate: admissionFormik.values.ugc12b === "yes",
      certificateDoc: (admissionFormik.values.collegeLocation === "rural" ||
        admissionFormik.values.collegeLocation === "tribal"),
    });

    // Check if there are any area validation errors
    if (Object.keys(areaErrors).length > 0) {
      const errorMessages = [];

      if (areaErrors.collegeLocation) errorMessages.push("College Location Is Required");
      if (areaErrors.ugc2f) errorMessages.push("ugc2f is required");
      if (areaErrors.ugc12b) errorMessages.push("ugc12b is required");
      if (areaErrors.ugc2fCertificate) errorMessages.push(areaErrors.ugc2fCertificate);
      if (areaErrors.ugc12bCertificate) errorMessages.push(areaErrors.ugc12bCertificate);
      if (areaErrors.certificateDoc) errorMessages.push(areaErrors.certificateDoc);

      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: `Please fix the following errors:\n${errorMessages.join('\n')}`,
      });
      return;
    }

    // If all validations pass, show confirmation and submit
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to submit the area details?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Submit",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        let url = `${config.url.FAC_URL}saveAreaType?areaType=${admissionFormik.values.collegeLocation}&certificateDoc=${admissionFormik.values.certificateDoc}&nacAvailable=${admissionFormik.values.nacAvailable}&ugc2f=${admissionFormik.values.ugc2f}&ugc2fCertificate=${admissionFormik.values.ugc2fCertificate}&ugc12b=${admissionFormik.values.ugc12b}&ugc12bCertificate=${admissionFormik.values.ugc12bCertificate}`;
        CommonAxiosPost(url, payload)
          .then((res) => {
            if (res?.data?.scode === "01") {
              successAlert2(res.data.sdesc);
              getAfterSubmit();
            } else {
              failureAlert(res.data.sdesc);
            }
          })
          .catch((err) => {
            console.error("Submission Error:", err);
            Swal.fire({
              text: "An error occurred during submission.",
              icon: "error",
            });
          });
      }
    });
  }
  console.log("admissionFormik?.errors", admissionFormik?.values);
  return (
    <>
      <FormikProvider value={admissionFormik}>
        <Form onSubmit={admissionFormik.handleSubmit}>
          {/* <fieldset 
         
          > */}
          <jnb.Row className="mb-3">
            <jnb.Col md={4}>
              <label className="fw-bold mb-1">
                College Located In
              </label>
              <Field
                as="select"
                name="collegeLocation"
                className="form-control"
                disabled={disableFields.coll_area_type ? true : false}
                onChange={(e) => {
                  const value = e.target.value;
                  admissionFormik.setFieldValue("collegeLocation", value);
                  admissionFormik.setFieldValue("certificateDoc", null);

                  const fileInput = document.querySelector('input[name="certificateDoc"]');
                  if (fileInput) {
                    fileInput.value = "";
                  }
                }}
              >
                <option value="">--Select--</option>
                <option value="rural">Rural</option>
                <option value="urban">Urban</option>
                <option value="tribal">Tribal</option>
              </Field>
              <ErrorMessage name="collegeLocation" component="div" className="text-danger small" />
            </jnb.Col>

            {(admissionFormik.values.collegeLocation === "rural" || admissionFormik.values.collegeLocation === "tribal") && (
              <jnb.Col md={4}>
                <label className="fw-bold mb-1">
                  Upload Certificate <span className="text-danger">*</span>
                </label>
                <input
                  type="file"
                  className="form-control"
                  name="certificateDoc"
                  accept=".pdf,.jpg,.jpeg,.png"
                  // disabled={freezeAreaType}
                  onChange={(e) => {
                    let filename = `certificateDoc`;
                    let path = "/Uploads/AffiliationPDFs/2023/";

                    ImagePdfBucket(e, admissionFormik, path, `certificateDoc`, filename, "pdf");
                  }}
                />
                {admissionFormik.values.certificateDoc && (
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={() => viewImage(admissionFormik.values.certificateDoc)}
                  ><FaEye />
                  </button>
                )}
                <ErrorMessage name="certificateDoc" component="div" className="text-danger small" />
              </jnb.Col>

            )}
            <jnb.Col md={4}>
              <label className="fw-bold mb-1">
                Year Of Establishment
              </label>


              <Field className="form-control" value={clgdata?.year_of_establishment} disabled />
            </jnb.Col>
            <jnb.Row className="mb-3">

              <jnb.Row className="mb-4 mt-3">

                <jnb.Col md={12}>
                  <h5 className="innerheader-new mb-3">
                    <span>🏆 NAAC Details</span>
                  </h5>
                  {clgdata?.naac_accrediated === "Yes" ? (
                    <div className="border rounded p-3" style={{ backgroundColor: '#f9f9f9' }}>
                      <div className="row text-center">
                        <div className="col">
                          <strong className="fw-28">📊NAAC CGPA:</strong> {clgdata?.latest_naac_cgpa || '-'}
                        </div>
                        <div className="col">
                          <strong>📅NAAC From Date: </strong> {clgdata?.latest_naac_from_date || '-'}
                        </div>
                        <div className="col">
                          <strong>⏰  NAAC Upto Date:</strong> {clgdata?.latest_naac_upto_date || '-'}
                        </div>
                        <div className="col">
                          <strong>📌NAAC Status:</strong> {clgdata?.naac_status || '-'}
                        </div>
                        <div className="col">
                          <strong>🔄 NAAC Previous Cycles:</strong> {nacDetails?.length || 'NA'}
                        </div>
                        <div className="col">
                          <strong>📄 NAAC Certificate:</strong> {clgdata?.latest_naac_certi ? (
                            <button type="button" className="btn btn-link btn-sm p-0" onClick={() => viewImage(clgdata?.latest_naac_certi)}>
                              <FaEye />
                            </button>
                          ) : '-'}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="alert alert-warning text-center">Not Yet Applied</div>
                  )}
                </jnb.Col>

              </jnb.Row>

              {/* )} */}

              {/* UGC Certificates in Tabular Format */}
              <h5 className="innerheader-new mb-3">
                <span><FaUniversity className="me-2" /> UGC DETAILS</span>
              </h5>
              <jnb.Row className="mb-4">
                <jnb.Col md={12}>
                  <div className="table-responsive">
                    <table className="table table-bordered" style={{ backgroundColor: '#f9f9f9' }}>
                      <thead className="table-secondary">
                        <tr>
                          <th style={{ width: '30%' }}>Certificate Type</th>
                          <th style={{ width: '20%' }}>Available?</th>
                          <th style={{ width: '50%' }}>Upload Certificate (if Yes)</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td className="fw-bold">UGC 2(F) Certificate</td>
                          <td>
                            <div>
                              <label className="me-3">
                                <Field
                                  type="radio"
                                  name="ugc2f"
                                  value="yes"
                                  onChange={(e) => {
                                    admissionFormik.setFieldValue("ugc2f", e.target.value);
                                    admissionFormik.setFieldTouched("ugc2f", true, false);
                                    if (e.target.value !== "yes") {
                                      admissionFormik.setFieldValue("ugc2fCertificate", "");
                                    }
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                />  &nbsp; Yes
                              </label>
                              <label>
                                <Field
                                  type="radio"
                                  name="ugc2f"
                                  value="no"
                                  onChange={(e) => {
                                    admissionFormik.setFieldValue("ugc2f", e.target.value);
                                    admissionFormik.setFieldTouched("ugc2f", true, false);
                                    admissionFormik.setFieldValue("ugc2fCertificate", "");
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                />  &nbsp;  No
                              </label>
                            </div>
                            <ErrorMessage name="ugc2f" component="div" className="text-danger small mt-1" />
                          </td>
                          <td>
                            {admissionFormik.values.ugc2f === "yes" && (
                              <>
                                <input
                                  type="file"
                                  className="form-control"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={(e) => {
                                    ImagePdfBucket(e, admissionFormik, "/Uploads/UGC2F/", "ugc2fCertificate", "ugc2fCert", "pdf");
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                />
                                {(admissionFormik.values.ugc2fCertificate !== null && admissionFormik.values.ugc2fCertificate !== "") && (
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm mt-1"
                                    onClick={() => viewImage(admissionFormik.values.ugc2fCertificate)}
                                  >
                                    <FaEye />
                                  </button>
                                )}
                                <ErrorMessage name="ugc2fCertificate" component="div" className="text-danger small" />
                              </>
                            )}
                          </td>
                        </tr>

                        {/* UGC 12(F) Row */}
                        {/* <tr>
                          <td className="fw-bold">UGC 12(F) Certificate</td>
                          <td>
                            <div>
                              <label className="me-3">
                                <Field type="radio" name="ugc12b" value="yes" 
                                // onChange={(e) => {
                                  // admissionFormik.setFieldValue("ugc12b", e.target.value);
                                  // admissionFormik.setFieldTouched("ugc12b", true, false);
                                // }}
                                /> Yes
                              </label>
                              <label>
                                <Field type="radio" name="ugc12b" value="no" 
                                // onChange={(e) => {
                                  // admissionFormik.setFieldValue("ugc12b", e.target.value);
                                  // admissionFormik.setFieldTouched("ugc12b", true, false);
                                // }}
                                 /> No
                              </label>
                         
                            </div>
                            <ErrorMessage name="ugc12b" component="div" className="text-danger small" />

                          </td>
                          <td>
                            {admissionFormik.values.ugc12b === "yes" && (
                              <>
                                <input
                                  type="file"
                                  className="form-control"
                                  // accept=".pdf,.jpg,.jpeg,.png"
                                  onChange={(e) => {
                                    ImagePdfBucket(e, admissionFormik, "/Uploads/UGC12F/", "ugc12bCertificate", "ugc12fCert", "pdf");
                                  }}
                                />
                                {admissionFormik.values.ugc12bCertificate && (
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm mt-1"
                                    onClick={() => viewImage(admissionFormik.values.ugc12bCertificate)}
                                  >
                                    <FaEye /> View
                                  </button>
                                )}
                                <ErrorMessage name="ugc12bCertificate" component="div" className="text-danger small" />
                              </>
                            )}
                          </td>
                        </tr> */}
                        {/* UGC 12(B) Row */}
                        <tr>
                          <td className="fw-bold">UGC 12(B) Certificate</td>
                          <td>
                            <div>
                              <label className="me-3">
                                <Field
                                  type="radio"
                                  name="ugc12b"
                                  value="yes"
                                  onChange={(e) => {
                                    admissionFormik.setFieldValue("ugc12b", e.target.value);
                                    admissionFormik.setFieldTouched("ugc12b", true, false);
                                    // Clear certificate when changing selection
                                    if (e.target.value !== "yes") {
                                      admissionFormik.setFieldValue("ugc12bCertificate", "");
                                    }
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                /> &nbsp;Yes
                              </label>
                              <label>
                                <Field
                                  type="radio"
                                  name="ugc12b"
                                  value="no"
                                  onChange={(e) => {
                                    admissionFormik.setFieldValue("ugc12b", e.target.value);
                                    admissionFormik.setFieldTouched("ugc12b", true, false);
                                    // Clear certificate when selecting No
                                    admissionFormik.setFieldValue("ugc12bCertificate", "");
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                />&nbsp; No
                              </label>
                            </div>
                            <ErrorMessage name="ugc12b" component="div" className="text-danger small mt-1" />
                          </td>
                          <td>
                            {admissionFormik.values.ugc12b === "yes" && (
                              <>
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={(e) => {
                                    ImagePdfBucket(e, admissionFormik, "/Uploads/UGC12F/", "ugc12bCertificate", "ugc12fCert", "pdf");
                                  }}
                                  disabled={disableFields.coll_area_type ? true : false}
                                />
                                {admissionFormik.values.ugc12bCertificate && (
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm mt-1"
                                    onClick={() => viewImage(admissionFormik.values.ugc12bCertificate)}
                                  >
                                    <FaEye />
                                  </button>
                                )}
                                <ErrorMessage name="ugc12bCertificate" component="div" className="text-danger small" />
                              </>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </jnb.Col>
              </jnb.Row>

            </jnb.Row>
            {/* {!freezeAreaType && ( */}
            {!disableFields.coll_area_type && (
              <jnb.Col>
                <div className="d-flex justify-content-end">
                  <button className="btn btn-primary" type="button" onClick={saveArea}>
                    Submit
                  </button>
                </div>
              </jnb.Col>
            )}
          </jnb.Row>
          {/* <fieldset disabled={hasExistingData}> */}
          <h5 className="mb-3 innerheader-new">
            <span>Admissions Details</span>
          </h5>
          <div className="table-responsive">
            <FieldArray name="admissionDetails">
              {() => (
                <table className="table table-bordered text-center">
                  <thead className="table-primary">
                    <tr>
                      <th rowSpan="3">Sl.No</th>
                      {/* <th rowSpan="3">Name of the Stream</th> */}
                      <th rowSpan="3" width="1000">
                        Name of the Single Major Programme
                      </th>
                      <th colSpan="3">Sanctioned Intake</th>
                      <th colSpan="3">Admitted</th>
                      <th colSpan="3">% Admissions</th>
                      <th colSpan="4">III year students appeared for examinations in AY 2025-26</th>
                    </tr>
                    <tr>
                      <th rowSpan="2">I Year</th>
                      <th rowSpan="2">II Year</th>
                      <th rowSpan="2">III Year</th>
                      <th rowSpan="2">I Year</th>
                      <th rowSpan="2">II Year</th>
                      <th rowSpan="2">III Year</th>
                      <th rowSpan="2">I Year</th>
                      <th rowSpan="2">II Year</th>
                      <th rowSpan="2">III Year</th>
                      <th colSpan="2">5th Sem</th>
                      <th colSpan="2">6th Sem</th>
                    </tr>
                    <tr>
                      <th>No. of students</th>
                      <th>% appeared</th>
                      <th>No. of students</th>
                      <th>% appeared</th>
                    </tr>
                  </thead>

                  <tbody>
                    {/* {admissionFormik.values.admissionDetails.map((row, index) => ( */}


                    {admissionFormik.values.admissionDetails.map((row, index) => {
                      if (row.CourseType === "PG ACADEMIC") {
                        return null;
                      }

                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td className="text-start">{row.stream_name}({row.single_major_name})</td>
                          {/* <td style={{ minWidth: "250px" }} className="text-start">{row.single_major_name}</td> */}
                          <td>
                            <Field name={`admissionDetails[${index}].sanctionedIntakeYear1`} style={{ minWidth: "90px" }} className="form-control" onKeyPress={allowNumbersOnly} />
                            <Field type="hidden" name={`admissionDetails[${index}].CourseType`} className="form-control" />

                            <ErrorMessage name={`admissionDetails[${index}].sanctionedIntakeYear1`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].sanctionedIntakeYear2`} style={{ minWidth: "90px" }} className="form-control " onKeyPress={allowNumbersOnly} />
                            <ErrorMessage name={`admissionDetails[${index}].sanctionedIntakeYear2`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].sanctionedIntakeYear3`} style={{ minWidth: "90px" }} className="form-control " onKeyPress={allowNumbersOnly} />
                            <ErrorMessage name={`admissionDetails[${index}].sanctionedIntakeYear3`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admittedYear1`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly}
                              //  onChange={(e) => {
                              //   const admitted = e.target.value;

                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].admittedYear1`,
                              //     admitted
                              //   );

                              //   const intake =
                              //     admissionFormik.values.admissionDetails[index].sanctionedIntakeYear1;

                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].admissionPercentYear1`,
                              //     calculatePercentage(admitted, intake)
                              //   );
                              // }}
                              onChange={(e) => handleAdmissionChange(index, "admittedYear1", e.target.value)}
                            />
                            <ErrorMessage name={`admissionDetails[${index}].admittedYear1`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admittedYear2`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly}

                              onChange={(e) => handleAdmissionChange(index, "admittedYear2", e.target.value)}
                            />
                            <ErrorMessage name={`admissionDetails[${index}].admittedYear2`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admittedYear3`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly}

                              onChange={(e) => handleAdmissionChange(index, "admittedYear3", e.target.value)}
                            />
                            <ErrorMessage name={`admissionDetails[${index}].admittedYear3`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admissionPercentYear1`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly} readOnly />
                            <ErrorMessage name={`admissionDetails[${index}].admissionPercentYear1`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admissionPercentYear2`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly} readOnly />
                            <ErrorMessage name={`admissionDetails[${index}].admissionPercentYear2`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].admissionPercentYear3`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly} readOnly />
                            <ErrorMessage name={`admissionDetails[${index}].admissionPercentYear3`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field
                              name={`admissionDetails[${index}].sem5Students`}
                              className="form-control"
                              onKeyPress={allowNumbersOnly}
                              // onChange={(e) => {
                              //   admissionFormik.handleChange(e);

                              //   // CLEAR percentage immediately when student value changes
                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].sem5Percent`,
                              //     ""
                              //   );
                              // }}
                              // onBlur={() => {
                              //   const sem5Students =
                              //     Number(admissionFormik.values.admissionDetails[index].sem5Students) || 0;

                              //   const total =
                              //     Number(admissionFormik.values.admissionDetails[index].admittedYear3) || 0;

                              //   const percentage =
                              //     total > 0 ? ((sem5Students / total) * 100).toFixed(2) : "0.00";

                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].sem5Percent`,
                              //     percentage
                              //   );
                              // }}
                              onChange={(e) => handleAdmissionChange(index, "sem5Students", e.target.value)}
                            />
                            {/* <Field name={`admissionDetails[${index}].sem5Students`} className="form-control " style={{ minWidth: "90px" }} onKeyPress={allowNumbersOnly} /> */}
                            <ErrorMessage name={`admissionDetails[${index}].sem5Students`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].sem5Percent`} className="form-control " onKeyPress={allowNumbersOnly} readOnly />
                            <ErrorMessage name={`admissionDetails[${index}].sem5Percent`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field
                              name={`admissionDetails[${index}].sem6Students`}
                              className="form-control"
                              onKeyPress={allowNumbersOnly}

                              // onChange={(e) => {
                              //   const value = e.target.value;

                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].sem6Students`,
                              //     value
                              //   );

                              //   // clear percentage while typing
                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].sem6Percent`,
                              //     ""
                              //   );
                              // }}

                              // onBlur={() => {
                              //   const sem6Students =
                              //     Number(admissionFormik.values.admissionDetails[index].sem6Students) || 0;

                              //   const total =
                              //     Number(admissionFormik.values.admissionDetails[index].admittedYear3) || 0;

                              //   const percentage =
                              //     total > 0 ? ((sem6Students / total) * 100).toFixed(2) : "0.00";

                              //   admissionFormik.setFieldValue(
                              //     `admissionDetails[${index}].sem6Percent`,
                              //     percentage
                              //   );
                              // }}
                              onChange={(e) => handleAdmissionChange(index, "sem6Students", e.target.value)}
                            />

                            <ErrorMessage name={`admissionDetails[${index}].sem6Students`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`admissionDetails[${index}].sem6Percent`} className="form-control " onKeyPress={allowNumbersOnly} readOnly />
                            <ErrorMessage name={`admissionDetails[${index}].sem6Percent`} component="div" className="text-danger small" />
                          </td>
                        </tr>
                      )
                    })}

                    {/* ))} */}
                  </tbody>
                </table>
              )}
            </FieldArray>
          </div>
          <fieldset disabled={hasExistingData}>
            <h5 className="mt-5 mb-3 innerheader-new">
              <span>Result analysis of Final Year Students(last three academic years)</span>
            </h5>
            <div className="table-responsive">
              <FieldArray name="resultAnalysis">
                {() => (
                  <table className="table table-bordered text-center">
                    <thead className="table-primary">
                      <tr>
                        <th rowSpan="2">Sl.No</th>
                        <th rowSpan="2">Name of the Stream</th>
                        {/* <th rowSpan="2">Name of UG Programme</th> */}
                        {/* <th colSpan="3">2020-2023</th> */}
                        <th colSpan="3">2021-2024</th>
                        <th colSpan="3">2022-2025</th>
                      </tr>
                      <tr>
                        {/* <th>No. of Students Appeared</th>
                        <th>No. of Students Passed</th>
                        <th>%</th> */}
                        <th>No. of Students Appeared</th>
                        <th>No. of Students Passed</th>
                        <th>%</th>
                        <th>No. of Students Appeared</th>
                        <th>No. of Students Passed</th>
                        <th>%</th>
                      </tr>
                    </thead>

                    <tbody>
                      {/* {admissionFormik.values.resultAnalysis.map((row, index) => ( */}
                      {admissionFormik.values.resultAnalysis
                        .filter((row) => row.stream_name !== "PG ACADEMIC")
                        .map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td className="text-start">{row.stream_name} ({row.ug_programme_name})</td>
                            {/* <td className="text-start">{row.ug_programme_name}</td> */}


                            {/* <td>
                            <Field name={`resultAnalysis[${index}].appearedYear1`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                              handleResultChange(index, "appearedYear1", e.target.value)
                            } />
                            <ErrorMessage name={`resultAnalysis[${index}].appearedYear1`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`resultAnalysis[${index}].passedYear1`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                              handleResultChange(index, "passedYear1", e.target.value)
                            }
                            />
                            <ErrorMessage name={`resultAnalysis[${index}].passedYear1`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field name={`resultAnalysis[${index}].percentYear1`} className="form-control " onKeyPress={allowNumbersOnly} readOnly
                            />
                            <ErrorMessage name={`resultAnalysis[${index}].percentYear1`} component="div" className="text-danger small" />
                          </td> */}


                            <td>
                              <Field name={`resultAnalysis[${index}].appearedYear2`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                                handleResultChange(index, "appearedYear2", e.target.value)
                              } />
                              <Field type="hidden" name={`resultAnalysis[${index}].CourseType`} className="form-control" />

                              <ErrorMessage name={`resultAnalysis[${index}].appearedYear2`} component="div" className="text-danger small" />
                            </td>
                            <td>
                              <Field name={`resultAnalysis[${index}].passedYear2`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                                handleResultChange(index, "passedYear2", e.target.value)
                              } />
                              <ErrorMessage name={`resultAnalysis[${index}].passedYear2`} component="div" className="text-danger small" />
                            </td>
                            <td>
                              <Field name={`resultAnalysis[${index}].percentYear2`} className="form-control " onKeyPress={allowNumbersOnly} disabled />
                              <ErrorMessage name={`resultAnalysis[${index}].percentYear2`} component="div" className="text-danger small" />
                            </td>
                            <td>
                              <Field name={`resultAnalysis[${index}].appearedYear3`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                                handleResultChange(index, "appearedYear3", e.target.value)
                              } />
                              <ErrorMessage name={`resultAnalysis[${index}].appearedYear3`} component="div" className="text-danger small" />
                            </td>
                            <td>
                              <Field name={`resultAnalysis[${index}].passedYear3`} className="form-control " onKeyPress={allowNumbersOnly} onChange={(e) =>
                                handleResultChange(index, "passedYear3", e.target.value)
                              } />
                              <ErrorMessage name={`resultAnalysis[${index}].passedYear3`} component="div" className="text-danger small" />
                            </td>
                            <td>
                              <Field name={`resultAnalysis[${index}].percentYear3`} className="form-control " onKeyPress={allowNumbersOnly} disabled />
                              <ErrorMessage name={`resultAnalysis[${index}].percentYear3`} component="div" className="text-danger small" />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </FieldArray>
            </div>

            {!hasExistingData ? (
              <jnb.Row className="mt-4">
                <jnb.Col>
                  <div className="d-flex justify-content-end">
                    <button className="btn btn-primary" type="submit">
                      Submit
                    </button>
                  </div>
                </jnb.Col>
              </jnb.Row>
            ) : (
              <jnb.Row className="mt-4">
                <jnb.Col>
                  <div className="d-flex justify-content-end">
                    <span className="text-success fw-bold">
                      ✓ Already Submitted
                    </span>
                  </div>
                </jnb.Col>
              </jnb.Row>
            )}
          </fieldset>
        </Form>
      </FormikProvider>
    </>
  );
};
export default AdmissionAndResultAnalysis;

